export default __webpack_public_path__ + "static/media/GalleryFirstVerticalFullSize.c0af00ce.png";